import React from "react"

const Spinner = () => {
   return <div className="spinner" />
}

export { Spinner as default }
